import {Component} from '@angular/core';

@Component({
    selector: 'app-custom-snackbar',
    templateUrl: './custom-snackbar.component.html',
    styleUrls: ['./custom-snackbar.component.scss'],
    standalone: false
})
export class CustomSnackbarComponent {

  refreshPage() {
    window.location.reload();
  }
}
